import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-548e709f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "src", "alt", "onClick"]

import { inject, onUnmounted, ref } from 'vue'
import { EventEmitter } from 'events'
// eslint-disable-next-line @typescript-eslint/no-var-requires
interface ILayer {
  id: number
  name: string
  imagery: string
  click?: () => void
}

// 声明卫星影像图

export default /*#__PURE__*/_defineComponent({
  __name: 'app-amap-layer-switcher',
  setup(__props) {

const imagery1 = require('@/assets/image/imagery1.jpg')
// eslint-disable-next-line @typescript-eslint/no-var-requires
const imagery2 = require('@/assets/image/imagery2.jpg')

const satellite = ref()
const emitter = inject<EventEmitter>('$map-emitter')

emitter?.once('init', (map) => {
  satellite.value = new AMap.TileLayer.Satellite({
    visible: false,
  })
  map.add(satellite.value)
})

const layers = ref<Array<ILayer>>([
  {
    id: 1,
    name: '地图',
    imagery: imagery1,
    click() {
      satellite.value?.hide()
    },
  },
  {
    id: 2,
    name: '影像',
    imagery: imagery2,
    click() {
      satellite.value?.show()
    },
  },
].reverse())
const sort = (item: ILayer) => {
  if (item.id !== layers.value[layers.value.length - 1].id) {
    const index = layers.value.findIndex((p) => p.id === item.id)
    layers.value.splice(index, 1)
    layers.value.push(item)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "app-amap-layer-switcher",
    style: _normalizeStyle({'--length': layers.value.length})
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layers.value, (item, i) => {
      return (_openBlock(), _createElementBlock("img", {
        key: item.id,
        id: `switcher`+item.id,
        style: _normalizeStyle({'--index':layers.value.length - i - 1}),
        src: item.imagery,
        alt: item.name,
        class: "item",
        onClick: ()=>{item.click();sort(item)}
      }, null, 12, _hoisted_1))
    }), 128))
  ], 4))
}
}

})